"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const InterviewSearchResult_1 = __importDefault(require("./InterviewSearchResult"));
const InterviewContext_1 = require("../../../contexts/InterviewContext");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const InterviewsCreateLink_1 = __importDefault(require("./InterviewsCreateLink"));
const interview_1 = require("evolution-common/lib/services/interviews/interview");
const InterviewSearchList = (props) => {
    const [data, setData] = react_1.default.useState([]);
    const { state, dispatch } = react_1.default.useContext(InterviewContext_1.InterviewContext);
    const fetchIdRef = react_1.default.useRef(0);
    // Function to fetch data from the server, with paging and filtering
    const fetchData = react_1.default.useCallback((accessCode) => __awaiter(void 0, void 0, void 0, function* () {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        // Make a query string from the filters
        try {
            const response = yield fetch(`/api/interviews/interviewByCode?accessCode=${accessCode}`);
            if (fetchId !== fetchIdRef.current) {
                // There was another query since, ignore
                return;
            }
            if (response.status === 200) {
                const jsonData = yield response.json();
                if (jsonData.interviews) {
                    setData(jsonData.interviews);
                    if (!(0, LodashExtensions_1._isBlank)(accessCode) &&
                        jsonData.interviews.length === 0 &&
                        props.autoCreateIfNoData &&
                        state.status !== 'creating') {
                        // automatically create new interview with this access code
                        dispatch({
                            type: 'createNew',
                            username: `${interview_1.INTERVIEWER_PARTICIPANT_PREFIX}_${(Math.ceil(Math.random() * 8999) + 1000).toString()}`,
                            queryData: props.queryData
                        });
                    }
                }
            }
            else {
                console.error('Invalid response code from server: ', response.status);
            }
        }
        catch (error) {
            console.error(`Error fetching user data from server: ${error}`);
            setData([]);
        }
    }), [state.status]);
    react_1.default.useEffect(() => {
        fetchData(state.response.accessCode);
    }, [state.response]);
    // TODO This is very specific to the interviewer use case, generalize it and use a function to generate username, maybe as prop
    return (react_1.default.createElement("ul", { className: "interview" },
        data.map((interview) => (react_1.default.createElement(InterviewSearchResult_1.default, { key: interview.uuid, interview: interview }))),
        react_1.default.createElement(InterviewsCreateLink_1.default, { queryData: props.queryData })));
};
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(InterviewSearchList);
//# sourceMappingURL=InterviewSearchList.js.map